import {paramsConvert} from "../../api/api";
import wxuserUtil from '../wxuserUtil';

/**
 * ------------------------------------------------------------------
 * 微信企业号授权
 * @author GLEN <zcslsf@gmail.com>
 * ------------------------------------------------------------------
 */

class WeChatAuth {
  constructor (config) {
    let defaultConfig = {
      appid: '',
      agentid : '',
      responseType: 'code',
      scope: 'snsapi_privateinfo ',
      getCodeCallback: () => {}
    }
    this.config = Object.assign(defaultConfig, config)
  }

  openAuthPage (redirectUri = window.location.href,to) {
    let redirectUriArr = redirectUri.split('#')
     window.sessionStorage.setItem('redirect_path', to.path);
     window.sessionStorage.setItem('redirect_query', paramsConvert(to.query));
    redirectUri = encodeURIComponent(redirectUriArr[0])
    this.removeAccessToken()
    this.removeAuthCode()
    
    let authPageBaseUri = 'https://open.weixin.qq.com/connect/oauth2/authorize'
    let authParams = `?appid=${this.config.appid}&redirect_uri=${redirectUri}&response_type=${this.config.responseType}&scope=${this.config.scope}&agentid=${this.config.agentid}#wechat_redirect`
    window.location.href = authPageBaseUri + authParams
  }

  setAuthCode (code) {
    if (!code) return false
    wxuserUtil.setCode(code);
    return true
  }

  getAuthCode () {
    let codeValue = wxuserUtil.getCode();
    if (!codeValue) return ''
    return codeValue
  }

  removeAuthCode () {
    wxuserUtil.removeCode();
  }

  removeUrlCodeQuery () {
    let location = window.location
    let search = location.search
    if (search) {
      search = search.substr(1)
    }
    let href = location.origin
    let pathName = location.pathname
    if (pathName) {
      href += pathName
    }
    let searchArr = search.split('&').filter(item => {
      if (item.indexOf('code=') !== -1) {
        return false
      }
      if (item.indexOf('state=') !== -1) {
        return false
      }
      return true
    })
    if (searchArr.length > 0) {
      href += '?' + searchArr.join('&')
    }
    let hash = location.hash
    if (hash) {
      href += hash
    }
    window.location.href = href
  }

  setAccessToken (accessToken) {
    if (!accessToken) return false
    window.sessionStorage.setItem('access_token', accessToken)
    return true
  }

  getAccessToken () {
    return window.sessionStorage.getItem('access_token')
  }

  removeAccessToken () {
    window.sessionStorage.removeItem('access_token')
  }

  next (next) {
    let self = this
    return (accessToken, to) => {
      if (accessToken) {
        self.setAccessToken(accessToken);
        to ? next(to) : next();
      } else {
        self.removeAccessToken();
        to && next(to)
      }
      self.removeAuthCode()
    }
  }

  getCodeCallback (to,from,next) {
   let _query = window.sessionStorage.getItem("redirect_query");
    _query=_query ? '?'+_query:'';
    console.log(window.sessionStorage.getItem("redirect_path") + _query);
    return this.config.getCodeCallback(this.getAuthCode(), this.next(next), window.sessionStorage.getItem("redirect_path") + _query)
  }
}

export default WeChatAuth



// WEBPACK FOOTER //
// ./src/common/wxwork-auth/wechat-auth.js